import {
  getString,
  getLeoUuid,
  LeoUUID,
} from "@surya-digital/leo-ts-types";

export interface RoleDTO {
  role: string;
  id: string;
}

export class Role {
  readonly isRoleRole: boolean = true;

  readonly role: string;
  readonly id: LeoUUID;


  constructor(
  role: string, 
  id: LeoUUID
  ) {
    Role.validateRole(role);
    this.role = role;
    this.id = id;
  }

  static fromDTO(dto: RoleDTO): Role {
    const role = getString(dto, "role", InvalidRoleRoleError);
    const id = getLeoUuid(dto, "id", InvalidRoleIdError);
    return new Role(
      role,
      id
    );
  }

  toDTO(): RoleDTO {
    const dto: RoleDTO = {
        role: this.role,
        id: this.id.toDTO()
    };
    return dto;
  }
  private static validateRole = (role: string): void => {
    if(role.trim().length === 0) {
      throw new InvalidRoleRoleNonEmptyError(
        `Attribute role cannot be an empty string.`
      );
    }
  }
  
}

Role.prototype.toString = function toString(): string {
  return `Role(role='${this.role}',id='${this.id}')`;
};

export class InvalidRoleError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRoleError";
  }
}
export class InvalidRoleRoleError extends InvalidRoleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRoleRoleError";
  }
}

export class InvalidRoleRoleNonEmptyError extends InvalidRoleRoleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRoleRoleNonEmptyError";
  }
}

export class InvalidRoleIdError extends InvalidRoleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRoleIdError";
  }
}
